<app-top-banner>
  <div body class="container not-found-container text-center mt-10p">
    <h1>404</h1>
    <h4>Page Not Found</h4>
    <p class="text-muted">We can't find the page that you're looking for.</p>
    <div class="mt-4">
      <a href="javascript:void" (click)="goBack()" class="btn btn-purple me-3">Go Back</a>
    </div>
  </div>
</app-top-banner>